import $ from 'jquery';

$(document).ready(function() {
    /*
    * Accordion filter
    */
    $(document).on('click', '.filter-toggle', function() {
        $('.questions-filter-container').stop().slideToggle(200);
        $('.questions-filter-container').toggleClass("filter-open");
    });

    $('.check-all').click(function() {
        var parentId = $(this).data('parent-id');
        var isChecked = $(this).is(':checked');

        $('input.child-term[data-parent-id="' + parentId + '"]').prop({
            checked: isChecked,
            disabled: isChecked,
        });
    });

    /*
    * Accordion functionality
    */
    $(document).on('click', '.accordion-button', function() {
        var targetId = $(this).attr('data-bs-target');
        var $targetElement = $(targetId);

        $('.accordion-collapse').not($targetElement).stop().slideUp(150).removeClass('show');
        $('.accordion-button').not(this).removeClass('active');

        if ($targetElement.hasClass('show')) {
            $targetElement.stop().slideUp(150).removeClass('show');
            $(this).removeClass('active');
        } else {
            $targetElement.stop().slideDown(150).addClass('show');
            $(this).addClass('active');
        }
    });
});


// WEBPACK FOOTER //
// ./scripts/questions.js